const EmitBubbling = Vue => {
    Vue.prototype.$emitBubbling = function (event, ...args) {
        let component = this;
        while (component.$parent) {
            component.$emit(event, ...args);
            component = component.$parent;
        }
    };
};
export default EmitBubbling;
